import * as angular from 'angular';
import { ManageUsersTableComponent } from './manage-users-table.component';

export const ManageUsersTableModule = angular
  .module('manageUsersTable', [])
  .component('manageUsersTable', ManageUsersTableComponent).name;
